import { render } from "./IconCar.vue?vue&type=template&id=62f07832"
import script from "./IconCar.vue?vue&type=script&lang=js"
export * from "./IconCar.vue?vue&type=script&lang=js"
script.render = render

export default script